import indigo from '@material-ui/core/colors/indigo';
import pink from '@material-ui/core/colors/pink';

export default {
  palette: {
    primary: {
      light: '#302f2f',
      main: '#302f2f',
      dark: '#302f2f',
      contrastText: '#fff'
    },
    secondary: {
      light: '#2A749B',
      main: '#2A749B',
      dark: '#2A749B',
      contrastText: '#fff'
    }
  },
  status: {
    danger: 'orange',
  },

  typography: {
    button: {
      fontWeight: 400,
      textAlign: 'capitalize'
    },
    fontFamily:'exoFont'
  },
};
